import { toastsIntlIds } from './toasts.ids';

export const toastsLangPtBr = {
  [toastsIntlIds.onLoadingToast.title]: 'Ação em andamento',
  [toastsIntlIds.onLoadingToast.description]:
    'Aguarde alguns instantes enquanto finalizamos esta ação',
};
